import {SELECT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: SELECT,
  attribute: 'repo_reason',
  label: {
    default: 'Deactivation Reason',
    short: 'Reason',
  },
  options: [
    {key: 'non_payment', label: 'Non-payment'},
    {key: 'misconduct', label: 'Misconduct'},
    {key: 'accident_non_compliance', label: 'Accident Non-compliance'},
    {key: 'vehicle_non_compliance', label: 'Vehicle Non-compliance'},
    {key: 'driver_non_qualification', label: 'Driver Non-Qualification'},
    {key: 'fraud_disputed_charges', label: 'Fraud – Disputed Charges'},
    {key: 'safety_program', label: 'Safety Program'},
  ],
});
